export const environment = {
  baseUrl: 'https://s-solution.org',
  // baseUrl: 'http://133.186.220.180:3000',
  nhn: {
    objectStorageContainer: 'test',
  },
};
